// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"f8008461a72bbc4f8e84","293":"6b149c44f38a931ce3aa","518":"696d979337c6d2111a82","779":"59d884684a413f3150a8"}[chunkId] + ".js";
};